<div class="p-container" *ngIf="this.showAppointment">
  <div class="w-full bg-card border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
      <!-- LEFT SIDE -->
      <div>
        <h1 class="md:text-3xl text-xl font-bold text-foreground">Book an Appointment</h1>
        <p class="mt-2 text-gray-500 text-base">Follow the steps below to schedule your visit.</p>
      </div>

      <!-- RIGHT SIDE USER PILL -->
      <div
        class="flex items-center gap-3 text-foreground bg-card-accent px-4 py-2 rounded-full shadow-sm border border-gray-200"
      >
        <span class="text-xl font-semibold font-medium">
          {{ user.userName }}
        </span>
        <i class="pi pi-user p-3 rounded-full bg-amber-200" style="font-size: 1rem" ></i>
      </div>
    </div>
  </div>

  <!-- calender section  -->

  <div class="mt-3 grid grid-cols-12 gap-4">
    <div class="md:col-span-4 col-span-12">
      <!-- calender -->
      <div class="bg-card-muted rounded-2xl shadow-md p-4">
        <h2 class="text-xl font-semibold mb-2">Select Appointment Date</h2>

        <p class="text-foreground-secondary mb-4">Choose a preferred date for your visit.</p>

        <p-calendar
          showIcon
          iconDisplay="input"
          [(ngModel)]="selectedDate"
          (onSelect)="onDateChange($event)"
          [minDate]="minDate"
          dateFormat="dd MM yy"
          placeholder="Select appointment date"
        >
        </p-calendar>
      </div>
      <!-- appoint type -->
      <div>
        <!-- STEP 3 CARD -->
        <div class="bg-card-muted rounded-2xl shadow-md p-4 mt-4">
          <!-- Section Header -->
          <h2 class="text-xl font-semibold mb-2">Select Appointment Type</h2>

          <p class="text-foreground-secondary mb-6">
            Choose how you want to attend the consultation
          </p>

          <!-- Cards -->
          <div class="flex gap-2 flex-col">
            <!-- Clinic Visit -->
            <div
              (click)="selectType(ConsultationType.Offline)"
              [ngClass]="{
                ' bg-primary-light shadow-sm shadow text-primary':
                  selectedType === ConsultationType.Offline,
                'border-gray-200 hover:border-primary hover:shadow-md':
                  selectedType !== ConsultationType.Offline,
              }"
              class="cursor-pointer border bg-card rounded-2xl p-3 transition-all duration-200"
            >
              <div class="flex gap-3">
                <div class="w-14 h-14 flex items-center justify-center rounded-xl bg-gray-100 mb-4">
                  <i class="pi pi-building text-2xl text-gray-600"></i>
                </div>

                <div>
                  <h3 class="text-lg font-semibold mb-2">Clinic Visit</h3>

                  <p class="text-foreground-secondary">Visit the clinic for consultation.</p>
                </div>
              </div>
            </div>

            <!-- Online Consultation -->
            <div
              (click)="selectType(ConsultationType.Online)"
              [ngClass]="{
                'bg-primary-light  text-primary': selectedType === ConsultationType.Online,
                'border-gray-200 hover:border-primary hover:shadow-md':
                  selectedType !== ConsultationType.Online,
              }"
              class="cursor-pointer bg-card border rounded-2xl p-3 transition-all duration-200"
            >
              <div class="flex gap-3">
                <div class="w-14 h-14 flex items-center justify-center rounded-xl bg-gray-100 mb-4">
                  <i class="pi pi-desktop text-2xl text-gray-600"></i>
                </div>

                <div>
                  <h3 class="text-lg font-semibold mb-2">Online Consultation</h3>

                  <p class="text-foreground-secondary">Consult via video call.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- appoint slotes  -->
    <div
      class="md:col-span-8 col-span-12 mt-3 md:mt-0 bg-card-muted rounded-2xl shadow-md p-4 relative"
    >
      <!-- STEP 2 CARD -->
      <div>
        <!-- Section Header -->
        <h2 class="text-xl font-semibold mb-2">Choose Available Time Slot</h2>
        <p class="text-foreground-secondary mb-6">Available slots for selected date</p>

        <!-- ✅ If Slots Available -->
        <ng-container *ngIf="availableSlots.length > 0; else noSlotsTemplate">
          <!-- Slot Grid -->
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <button
              *ngFor="let slot of availableSlots"
              type="button"
              (click)="selectSlot(slot)"
              [ngClass]="{
                'bg-primary-50 border-primary shadow-sm text-primary': selectedSlotId === slot.id,
                'border-gray-200 bg-white text-gray-700 hover:border-primary hover:shadow-md':
                  selectedSlotId !== slot.id,
              }"
              class="flex items-center gap-3 border rounded-xl px-4 py-3 transition-all duration-200"
            >
              <i class="pi pi-clock text-lg"></i>
              <span class="font-medium">{{ slot.slot_time }}</span>
            </button>
          </div>

          <!-- Start Assessment Button -->
          <div class="flex justify-end mt-8">
            <p-button
              label="Let's Start Assessment"
              icon="pi pi-check"
              (click)="submitAppointment()"
              [disabled]="!selectedSlotId || !selectedDate || !selectedType"
              styleClass="p-button-primary px-6 py-3 rounded-xl shadow-md"
            >
            </p-button>
          </div>
        </ng-container>

        <!-- ❌ No Slots Template -->
        <ng-template #noSlotsTemplate>
          <div
            class="flex flex-col items-center justify-center py-12 bg-gray-50 rounded-xl border border-dashed border-gray-300"
          >
            <i class="pi pi-calendar-times text-4xl text-red-400 mb-4"></i>

            <h3 class="text-lg font-semibold text-gray-700">No Slots Available</h3>

            <p class="text-gray-500 mt-2 text-center max-w-sm">
              Unfortunately, there are no available slots for the selected date. Please choose
              another date.
            </p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- pre info for User  -->
</div>



<!-- <patient-pre-assesment
  *ngIf="this.showPreAssesmentQue"
  [AppointmentDetails]="appointmenData"
></patient-pre-assesment> -->


<div>
    <patient-payment-summury
      *ngIf="showSummury"
      [summaryData]="appointmenData"
    ></patient-payment-summury>
  </div>
